// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2blal","Logo":"Toolbar_Logo__30rkx","DesktopOnly":"Toolbar_DesktopOnly__2tqKP"};